import React from 'react'
import './Inicio.css'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import imagenInicio from '../images/imagen-inicio.png';
import { Button } from 'flowbite-react';
import { Link } from "react-scroll";
import 'animate.css';


const buttonStyleAzul = {
    backgroundColor: '#111125',
    color: 'white',
    borderRadius: '28px',
    fontFamily: 'Inter, sans-serif', 
    fontSize: '24px',
    fontWeight: 'semi-bold',
  };

function Inicio() {
  return (
    <Container className='contenedor-inicio animate__animated animate__fadeInUp'>
        <Row className='d-flex align-items-stretch'>
            <Col className='col-md-8 col-sm-12'>
                <h1 className='tituloMarca'>FHP</h1>
                <h2 className='tituloinicio '>En FHP nos enfocamos en ser tu <span className='titulo-azul'>socio de crecimiento </span></h2>
                <p className='mt-2 descripcion'>Como socio de crecimiento lo único que buscamos realmente es hacer crecer tu empresa, por lo que vamos a cubrir las áreas que sean necesarias para que tu negocio llegue al éxito.</p>
                <div className='contenedor-boton gap-2'>
                <Link  to='calendly' smooth={false} offset={-70} duration={700} color="text">
                    <Button className='mt-10 p-0' size="lg" style={buttonStyleAzul}>Agendemos una llamada</Button>
                </Link>
                </div>
            </Col>
            <Col className="d-flex align-items-center col-md-4 d-none d-sm-block">
                <div className='contenedor-imagen'>
                    <img src={imagenInicio} className="imagenInicio d-flex align-items-center" alt="logo" />
                </div>
            </Col>
        </Row>
        
        

    </Container>
  )
}

export default Inicio
